import { useEffect } from 'react';

export default function useInitBranch() {
  useEffect(() => {
    async function initBranchSDK() {
      const BranchSDK = (await import('branch-sdk')).default;
      BranchSDK?.init(process.env.NEXT_PUBLIC_BRANCH_KEY!);
    }

    initBranchSDK();
  }, []);
}
